import React, { Suspense } from 'react'
import { HelmetProvider } from 'react-helmet-async'
import ReactDOM from 'react-dom'
import store from './store'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { Provider } from 'react-redux'
import initFaLibrary from 'Modules/FALibrary'
import * as Sentry from '@sentry/browser'
import AuthGate from 'Components/AuthGate'
import 'bootstrap/dist/css/bootstrap.min.css'
import './css/theme-minimal.css'
import './css/hmi.css'
import './i18n'

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: 'https://6dc2099365d9492fb82e1c60762486fb@sentry.io/1460557',
    environment: process.env.NODE_ENV
  })
}


if (typeof initFaLibrary === 'function') {
  try {
    initFaLibrary()
  } catch (e) {
    console.warn('initFaLibrary failed:', e)
  }
}


const appContent = (
  <AuthGate>
    <HelmetProvider>
      <Suspense fallback={<div style={{display: 'flex', height: '100vh', justifyContent: 'center', alignItems: 'center'}}>Loading Translations...</div>}>
        <App />
      </Suspense>
    </HelmetProvider>
  </AuthGate>
)

ReactDOM.render(
  <Provider store={store}>
    {appContent}
  </Provider>,
  document.getElementById('root')
)
console.log('[DEBUG HMI] 3. ReactDOM.render executed')

serviceWorker.unregister()
